import { Box, Drawer, Stack, Button, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Scrollbar from "src/components/Scrollbar";
import Logo from "src/components/logo";
import { NavSectionVertical } from "src/components/nav-section";
import { NAVBAR } from "src/config";
import useAuth from "src/hooks/useAuth";
import useCollapseDrawer from "src/hooks/useCollapseDrawer";
import useResponsive from "src/hooks/useResponsive";
import cssStyles from "src/utils/cssStyles";
import CollapseButton from "./CollapseButton";
import NavbarAccount from "./NavbarAccount";

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

const NavbarVertical = ({ isOpenSidebar, onCloseSidebar, config }) => {
  const theme = useTheme();
  const { pathname } = useLocation();

  const isDesktop = useResponsive("up", "lg");
  const { user } = useAuth();
  const userId = Number(user?.id ?? user?.user_id ?? user?.userId);
  const activeStatus = user?.activePackageStatus;
  const newRank = user?.uni_level_rank?.id;

  
const getRankIconSrc = (newRank) => {
  const id = Number(newRank);
  if (!Number.isInteger(id) || id < 1 || id > 14) return null;
  return `/icons/${id}.svg`;
};

  const {
    isCollapse,
    collapseClick,
    collapseHover,
    onToggleCollapse,
    onHoverEnter,
    onHoverLeave,
  } = useCollapseDrawer();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: "center" }),
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{ width: "100%" }} // Ensure the Stack takes full width
        >
          {/* Spacer to push Logo to the center */}
          <Box sx={{ flex: 1 }} />
         <Box sx={{display:"flex",mr:3.6}}>
           {userId <= 5042 && activeStatus === true && (
            <Box
              component="img"
              src="/icons/5k.svg"
              alt="5k"
              sx={{ width: "32px", height: "32px" }}
            />
          )}
              {activeStatus === true && (
                <Box
                  component="img"
                  src={getRankIconSrc(newRank)}
                  alt={`rank-${newRank}`}
                  sx={{ width: 30, height: 30 ,pr:0.5}}
                />
                )}
         </Box>
          <Logo />

          {/* Spacer to balance the layout and keep CollapseButton at the end */}
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            {isDesktop && !isCollapse && (
              <CollapseButton
                onToggleCollapse={onToggleCollapse}
                collapseClick={collapseClick}
              />
            )}
          </Box>
        </Stack>

        {/* <NavbarAccount isCollapse={isCollapse} /> */}
      </Stack>

      <NavSectionVertical navConfig={config} isCollapse={isCollapse} />

      {!JSON.parse(localStorage.getItem('isAdmin') || 'false') && (
        <Box sx={{ml:3,p:1,mr:4 }}>
          Support: (855) 775-3688
        </Box>
      )}

      <Box sx={{ flexGrow: 1 }} />
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: "center" }),
        }}
      >
        <NavbarAccount isCollapse={isCollapse} />
      </Stack>
    </Scrollbar>
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse
            ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH
            : NAVBAR.DASHBOARD_WIDTH,
        },
        ...(collapseClick && {
          position: "absolute",
        }),
      }}
    >
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          PaperProps={{
            sx: {
              width: NAVBAR.DASHBOARD_WIDTH,
              borderRightStyle: "dashed",
              bgcolor: "background.paper",
              transition: (theme) =>
                theme.transitions.create("width", {
                  duration: theme.transitions.duration.standard,
                }),
              ...(isCollapse && {
                width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
              }),
              ...(collapseHover && {
                ...cssStyles(theme).bgBlur(),
                boxShadow: (theme) => theme.customShadows.z24,
              }),
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
};

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default NavbarVertical;
